import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useCallback, useMemo, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControl, InputLabel, Input } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';

import { useRouter } from 'src/routes/hooks';
import Swal from 'sweetalert2';

import Iconify from 'src/components/iconify';
import FormProvider, { RHFTextField, RHFUpload, RHFAutocomplete } from 'src/components/hook-form';
import { format } from 'date-fns';

import httpCommon from 'src/http-common';
// ----------------------------------------------------------------------

export default function UserNewEditForm({ currentUser }) {
  const router = useRouter();

  const getId = localStorage.getItem('QRId');
  const getHsp = localStorage.getItem('Hsp');

  const [DrpData, setDrpData] = useState([]);
  const [UserInfoData, setUserInfoData] = useState([]);
  const [phnNo, setPhnNo] = useState('');
  const Username = UserInfoData?.emp_mst_name || '';
  const userdept = UserInfoData?.emp_det_costcenter || '';

  const [NameDT, setNameDT] = useState(Username);
  const [DeptDT, setDeptDT] = useState(userdept);
  const [PhnDT, setPhnDT] = useState(phnNo);

  const [DrpDataLeval, setDrpDataLeval] = useState([]);

  const [errorMsg, setErrorMsg] = useState('');
  // const [selectedValueLeval, setSelectedValueLeval] = useState(null);

  const rawDate = new Date();

  const formattedDate = format(rawDate, 'dd-MM-yyyy HH:mm', { useAdditionalDayOfYearTokens: true });

  // chdck setting mode
  useEffect(() => {
    document.body.classList.remove('customNav');
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem('dataDark');
      // console.log("storedValue++", storedValue);
      if (storedValue === 'dark') {
        document.body.classList.add('custom-darkClass');
      } else {
        document.body.classList.remove('custom-darkClass');
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove('custom-darkClass');
    };
  }, []);

  useEffect(() => {
    const fetchuserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
      };
      try {
        const response = await httpCommon.post('/GetUserInfo.php', requestData);

        if (response.data.status === 'SUCCESS') {
          setUserInfoData(response.data.data[0]);
          setPhnNo(response.data.data[0].emp_mst_homephone);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Call the fetchuserInfo function when the component mounts.
    fetchuserInfo();
  }, [getHsp, getId]);

  useEffect(() => {
    const servicesDropdown = async () => {
      try {
        const response = await httpCommon.get(`/servicesDropdown.php?site_cd=H03`);
        //  console.log("SdropDown",response);
        if (response.data.status === 'SUCCESS') {
          setDrpData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    servicesDropdown();
  }, []);

  useEffect(() => {
    const LevalDropdown = async () => {
      try {
        const response = await httpCommon.get(`/levelDropdown?site_cd=H03`);
        // console.log("SdropDown3",response);
        if (response.data.status === 'SUCCESS') {
          setDrpDataLeval(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    LevalDropdown();
  }, []);

  const NewUserSchema2 = Yup.object().shape({
    reqDescriptin: Yup.string().required('Request Description is required'),
    location: Yup.string().required('Room No is required'),
    service: Yup.string().required('Service is required'),
    level: Yup.string().required('Level is required'),
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    department: Yup.string().required('Department is required'),
    contactNo: Yup.string().required('Contact number is required'),
    service: Yup.string().required('Service is required'),
    level: Yup.string().required('Level is required'),
    reqDescriptin: Yup.string().required('Request Description is required'),
    location: Yup.string().required('Room No is required'),
    // images: Yup.mixed().nullable().required('Images is required'),
    // not required
    status: Yup.string(),
    isVerified: Yup.boolean(),
  });

  const selectedSchema =
    NameDT !== '' || DeptDT !== '' || PhnDT !== '' ? NewUserSchema2 : NewUserSchema;

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });
  useEffect(() => {
    setNameDT(Username);
    setDeptDT(userdept);
    setPhnDT(phnNo);
  }, [Username, userdept, phnNo]);
  // console.log('Methods:', methods);
  const {
    watch,
    setValue,
    trigger,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  // Define the field names you want to check
  const [errorMessage, setErrorMessage] = useState('');
  const values = watch();

  const handleNameChange = (event) => {
    //  setNameDT(event.target.value);
    const newValue = event.target.value;

    if (newValue === '') {
      // Input field is empty
      setNameDT(''); // Clear the state or set it to an empty string
    } else {
      // Input field is not empty
      setNameDT(newValue); // Update the state with the new value
    }
  };

  const handleDeptChange = (event) => {
    setDeptDT(event.target.value);
  };
  const handlePhnChange = (event) => {
    setPhnDT(event.target.value);
  };

  const onSubmit = handleSubmit(async (data) => {
    if (NameDT !== '' || DeptDT !== '' || PhnDT !== '') {
      setValue('name', NameDT);
      setValue('department', DeptDT);
      setValue('contactNo', PhnDT);
    }

    try {
      const requestData = {
        ...data,
        employeeID: getId,
        site_cd: getHsp,
      };
      console.log('res__', requestData);
      const response = await httpCommon.post('/insertWorkReq.php', requestData);
      console.log('res__', response);
      if (response.data.status === 'SUCCESS') {
        Swal.fire({
          title: `Work Request No ${response.data.ROW_ID}`,
          text: 'Your work request created successfully',
          icon: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            router.push('/dashboard/user/list');
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `${response.data.message}`,
        });
      }
    } catch (error) {
      console.error(error);
    }
  });

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const images = watch('images') || [];

      // Check if the total number of selected files exceeds 3
      if (images.length + acceptedFiles.length > 3) {
        setErrorMessage('You can only select up to 3 photos.');

        // Clear the error message after 3 seconds
        setTimeout(() => {
          setErrorMessage('');
        }, 6000);

        return; // Prevent adding more than 3 photos
      }
      setErrorMessage('');

      // Function to convert a file to base64
      const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      const newFiles = await Promise.all(
        acceptedFiles.map(async (file) => {
          const base64Data = await fileToBase64(file);
          return { ...file, preview: URL.createObjectURL(file), base64: base64Data };
        })
      );

      setValue('images', [...images, ...newFiles], { shouldValidate: true });
    },
    [setValue, watch]
  );

  const handleRemoveFile = useCallback(
    (inputFile) => {
      const filtered = values.images.filter((file) => file.preview !== inputFile.preview);
      setValue('images', filtered);
    },
    [setValue, values.images]
  );

  const handleRemoveAllFiles = useCallback(() => {
    setValue('images', []);
  }, [setValue]);

  const handleServiceChange = (event, newValue) => {
    const selectedOption = DrpData.find((item) => item.mnt_svc_desc === newValue);
    if (selectedOption) {
      // Use setValue from RHF to update the field value
      setValue('service', selectedOption.mnt_svc_svc_cd);
      trigger('service'); // Manually trigger validation
    }
  };
  // console.log("UserInfoData__",UserInfoData.emp_mst_homephone);
  // console.log("kkk__",Username);

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Grid container spacing={4}>
        <Grid xs={12} md={5}>
          <Card sx={{ px: 3, pb: 5 }}>
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              Requester Information
            </Typography>

            <Box display="flex" flexDirection="column" rowGap={3}>
              {/* <TextField id="filled-basic" label="Employee ID" disabled variant="filled"  defaultValue={getId} /> */}
              <div className="usrFrmFld">
                <FormControl>
                  <InputLabel>Employee ID</InputLabel>
                  <Input type="text" name="name" disabled defaultValue={getId || ''} />
                </FormControl>
              </div>

              {(() => {
                if (Username) {
                  return (
                    <div className="usrFrmFld">
                      <FormControl>
                        <InputLabel>Name</InputLabel>
                        <Input
                          type="text"
                          name="name"
                          onChange={(e) => handleNameChange(e)}
                          defaultValue={Username}
                        />
                      </FormControl>
                    </div>
                  );
                }
                return (
                  <div className="fuWdt">
                    <RHFTextField
                      id="outlined-basic"
                      name="name"
                      label="Name"
                      variant="filled"
                      onChange={handleNameChange}
                    />
                    {errorMsg && <p className="errormessage">{errorMsg}</p>}
                  </div>
                );
              })()}
              <div>
                {(() => {
                  if (userdept) {
                    return (
                      <div className="usrFrmFld">
                        <FormControl>
                          <InputLabel>Department</InputLabel>
                          <Input
                            type="text"
                            name="department"
                            onChange={handleDeptChange}
                            defaultValue={userdept || ''}
                          />
                        </FormControl>
                      </div>
                    );
                  }
                  return (
                    <div className="fuWdt">
                      <RHFTextField
                        id="outlined-basic"
                        name="department"
                        label="Department"
                        variant="filled"
                        onChange={handleDeptChange}
                      />
                    </div>
                  );
                })()}
              </div>
              <div>
                {(() => {
                  if (phnNo) {
                    return (
                      <div className="usrFrmFld">
                        <FormControl>
                          <InputLabel>Contact No</InputLabel>
                          <Input
                            type="text"
                            name="contactNo"
                            onChange={handlePhnChange}
                            defaultValue={phnNo || ''}
                          />
                        </FormControl>
                      </div>
                    );
                  }
                  return (
                    <div className="fuWdt">
                      <RHFTextField
                        id="outlined-basic"
                        name="contactNo"
                        label="Contact No"
                        variant="filled"
                        onChange={handlePhnChange}
                      />
                    </div>
                  );
                })()}
              </div>
            </Box>
          </Card>
        </Grid>

        <Grid xs={12} md={7}>
          <Card sx={{ px: 3, pb: 5 }}>
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              Work Request Information
            </Typography>

            <Box display="flex" flexDirection="column" rowGap={3}>
              <div className="usrFrmFld">
                <FormControl>
                  <InputLabel>Request Date</InputLabel>
                  <Input
                    type="text"
                    name="requestDate"
                    disabled
                    defaultValue={formattedDate || ''}
                  />
                </FormControl>
              </div>
              <div className="usrFrmFldTwo">
                <RHFAutocomplete
                  name="service"
                  label="Service"
                  options={DrpData.map((DrpData2) => DrpData2.mnt_svc_desc)}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  onChange={handleServiceChange}
                  renderOption={(props, option) => {
                    const { mnt_svc_desc } = DrpData.filter(
                      (DrpData1) => DrpData1.mnt_svc_desc === option
                    )[0];

                    if (!mnt_svc_desc) {
                      return null;
                    }

                    return (
                      <li {...props} key={mnt_svc_desc}>
                        <Iconify key={mnt_svc_desc} width={28} sx={{ mr: 1 }} />
                        {mnt_svc_desc}
                      </li>
                    );
                  }}
                />
              </div>
              <div className="usrFrmFldTwo">
                <RHFAutocomplete
                  name="level"
                  label="Level"
                  options={DrpDataLeval.map((DrpDataLeval2) => DrpDataLeval2.ast_lvl_desc)}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderOption={(props, option) => {
                    const { ast_lvl_desc } = DrpDataLeval.filter(
                      (DrpDataLeval1) => DrpDataLeval1.ast_lvl_desc === option
                    )[0];

                    if (!ast_lvl_desc) {
                      return null;
                    }

                    return (
                      <li {...props} key={ast_lvl_desc}>
                        <Iconify key={ast_lvl_desc} width={28} sx={{ mr: 1 }} />
                        {ast_lvl_desc}
                      </li>
                    );
                  }}
                />
              </div>
              <div className="usrFrmFldTwo">
                <RHFTextField
                  name="location"
                  variant="filled"
                  label="Room No/Location Description(*Please Specify Block, Level & Location Description) :"
                />
              </div>
              <div className="usrFrmFldTwo">
                <RHFTextField
                  name="reqDescriptin"
                  variant="filled"
                  label="Request Description"
                  multiline
                  rows={4}
                />
              </div>
              <div className="usrFrmFldTwo">
                {errorMessage && <div className="erMsg">{errorMessage}</div>}
                {/* File upload component */}
                <RHFUpload
                  multiple
                  thumbnail
                  name="images"
                  maxSize={3145728}
                  onDrop={handleDrop}
                  onRemove={handleRemoveFile}
                  onRemoveAll={handleRemoveAllFiles}
                  onUpload={() => console.info('ON UPLOAD')}
                />
              </div>
            </Box>
          </Card>

          <Stack alignItems="inherit" sx={{ mt: 2 }}>
            <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
              Save
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>
    </FormProvider>
  );
}

UserNewEditForm.propTypes = {
  currentUser: PropTypes.object,
};
